import { type Address } from "@jti/fe-common";

const hasAnyBillingAddressValue = (address: Address | null | undefined): address is Address => {
  if (!address) {
    return false;
  }

  return [
    address.firstname,
    address.lastname,
    address.streetName,
    address.streetNumber,
    address.city,
    address.postcode,
  ].some((value) => Boolean(value?.trim()));
};

export const mergeBillingAddress = (
  address: Address | null | undefined,
  billingAddressFromForm: Address | null
): Address | null => {
  if (!hasAnyBillingAddressValue(billingAddressFromForm)) {
    return address ?? null;
  }

  if (!address) {
    return billingAddressFromForm;
  }

  const definedFormFields = Object.fromEntries(
    Object.entries(billingAddressFromForm).filter(([, value]) => value != null)
  );

  return { ...address, ...definedFormFields };
};
